import { getMimeTypeFromFileName } from "@validereinc/utilities";
import { nanoid } from "nanoid";
import type { FileUploadedRefType } from "./types";

export const getUnknownValueAsValidFileValue = (
  value: unknown
): File[] | undefined =>
  value
    ? value instanceof FileList || Array.isArray(value)
      ? Array.from(value)
      : value instanceof File
        ? [value]
        : undefined
    : undefined;

export const getFileForUploadedFile = (
  uploadedFile: FileUploadedRefType,
  allFiles: FileExtended[]
) => {
  if (!allFiles) {
    const mimeType = getMimeTypeFromFileName(uploadedFile.name);

    return new FileExtended(
      new File([], uploadedFile.name, mimeType ? { type: mimeType } : undefined)
    );
  }

  return (
    allFiles.find(
      (f) =>
        (f.fileUploaded?.ref !== undefined &&
          uploadedFile.ref !== undefined &&
          f.fileUploaded?.ref === uploadedFile.ref) ||
        (f.fileUploaded?.name !== undefined &&
          uploadedFile.name !== undefined &&
          f.fileUploaded?.name === uploadedFile.name)
    ) ?? null
  );
};

export class FileExtended<T extends FileUploadedRefType = FileUploadedRefType> {
  id: string;
  file: File | null = null;
  fileUploaded?: T;
  percentageProcessed?: number;
  percentageProcessedLabel?: string;
  error?: unknown;
  abortController = new AbortController();
  startedProcessing = false;

  constructor(
    file: File | null,
    meta?: {
      id?: string;
      fileUploaded?: T;
      percentageProcessed?: number;
      percentageProcessedLabel?: string;
      error?: unknown;
      startedProcessing?: boolean;
    }
  ) {
    // every file is assigned a unique randomly generated ID immediately
    this.id = meta?.id ?? nanoid(6);
    this.file = file;
    this.fileUploaded = meta?.fileUploaded;
    this.percentageProcessed = meta?.percentageProcessed;
    this.percentageProcessedLabel = meta?.percentageProcessedLabel;
    this.error = meta?.error;
    this.startedProcessing = meta?.startedProcessing ?? false;
  }
}
